/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AssignMultiplePersonsToMultipleSkillsInput = {
    skillIds?: Array<string | null> | null | undefined;
    personIds?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type assignMultiplePersonsToMultipleSkillsMutationVariables = {
    input: AssignMultiplePersonsToMultipleSkillsInput;
};
export type assignMultiplePersonsToMultipleSkillsMutationResponse = {
    readonly assignMultiplePersonsToMultipleSkills: {
        readonly skills: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null;
            readonly persons: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly fullName: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
};
export type assignMultiplePersonsToMultipleSkillsMutation = {
    readonly response: assignMultiplePersonsToMultipleSkillsMutationResponse;
    readonly variables: assignMultiplePersonsToMultipleSkillsMutationVariables;
};



/*
mutation assignMultiplePersonsToMultipleSkillsMutation(
  $input: AssignMultiplePersonsToMultipleSkillsInput!
) {
  assignMultiplePersonsToMultipleSkills(input: $input) {
    skills {
      id
      name
      persons {
        edges {
          node {
            id
            fullName
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "AssignMultiplePersonsToMultipleSkillsInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignMultiplePersonsToMultipleSkillsPayload",
    "kind": "LinkedField",
    "name": "assignMultiplePersonsToMultipleSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Skill",
        "kind": "LinkedField",
        "name": "skills",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonTypeConnection",
            "kind": "LinkedField",
            "name": "persons",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fullName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assignMultiplePersonsToMultipleSkillsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignMultiplePersonsToMultipleSkillsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "assignMultiplePersonsToMultipleSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation assignMultiplePersonsToMultipleSkillsMutation(\n  $input: AssignMultiplePersonsToMultipleSkillsInput!\n) {\n  assignMultiplePersonsToMultipleSkills(input: $input) {\n    skills {\n      id\n      name\n      persons {\n        edges {\n          node {\n            id\n            fullName\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b500904b0e339f3b9563bded285838cf';
export default node;
